import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { saveServiceCategory, generateServiceCategorySlug } from "@/lib/api/services.functions";
import { AdminFormFooter } from "@/components/admin/AdminFormFooter";
import { AdminPageHeader } from "@/components/admin/AdminPageHeader";
import { AdminPageShell } from "@/components/admin/AdminPageShell";
import { ContentAdminTabs } from "@/components/admin/ContentAdminTabs";
import { SlugField } from "@/components/admin/SlugField";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export const Route = createFileRoute("/admin/services/new")({
  component: NewServicePage,
});

function NewServicePage() {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");
  const [short, setShort] = useState("");
  const [intro, setIntro] = useState("");
  const [saving, setSaving] = useState(false);

  async function handleSave() {
    setSaving(true);
    try {
      const cat = await saveServiceCategory({ data: { name, slug: slug || undefined, short, intro, items: [] } });
      toast.success("Category created");
      navigate({ to: "/admin/services/$id", params: { id: cat!.id } });
    } catch (e) {
      toast.error(e instanceof Error ? e.message : "Failed to create");
    } finally {
      setSaving(false);
    }
  }

  return (
    <AdminPageShell>
      <AdminPageHeader title="New service category" />
      <ContentAdminTabs
        settingsLabel="Category settings"
        settingsForm={
          <div className="space-y-4">
            <div className="space-y-2"><Label>Name</Label><Input value={name} onChange={(e) => setName(e.target.value)} /></div>
            <SlugField
              title={name}
              slug={slug}
              onSlugChange={setSlug}
              onGenerate={() => generateServiceCategorySlug({ data: { name } })}
            />
            <div className="space-y-2"><Label>Short</Label><Textarea value={short} onChange={(e) => setShort(e.target.value)} /></div>
            <div className="space-y-2"><Label>Intro</Label><Textarea value={intro} onChange={(e) => setIntro(e.target.value)} /></div>
          </div>
        }
      />
      <AdminFormFooter cancelTo="/admin/services" onSave={handleSave} saving={saving} saveLabel="Create" savingLabel="Creating…" />
    </AdminPageShell>
  );
}
